import { createGlobalStyle, css } from "styled-components";

const scrollbarStyles = css`
  /* Custom scrollbar styles for WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    width: 15px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.MSBackgroundLight};
  }

  /* Thumb */
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.MSBackground};
    box-shadow: ${(props) => props.theme.standardBoxShadow};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #61dafb;
  }

  &::-webkit-scrollbar-button:single-button:vertical:increment {
    background-color: ${(props) => props.theme.MSBackground};
    box-shadow: ${(props) => props.theme.standardBoxShadow};
  }

  &::-webkit-scrollbar-button:single-button:vertical:decrement {
    background-color: ${(props) => props.theme.MSBackground};
    box-shadow: ${(props) => props.theme.standardBoxShadow};
  }
`;

export const GlobalStyles = createGlobalStyle`
  /* Apply scrollbar styles to all scrollable elements */
  * {
    ${scrollbarStyles}
  }

  /* Apply to body and html for the main page scroll */
  html, body {
    ${scrollbarStyles}
  }

  /* Desktop icons: hover lift, press squish, Windows-style blue selection */
  [data-desktop-icon] {
    user-select: none;
  }

  [data-desktop-icon] img {
    transition: transform 0.15s ease, filter 0.15s ease;
  }

  [data-desktop-icon]:hover img {
    transform: translateY(-3px);
  }

  [data-desktop-icon]:active img {
    transform: scale(0.9);
  }

  /* XP-style white labels on the desktop so every wallpaper stays readable */
  [data-desktop-icon] > div:last-child {
    color: #fff;
    text-shadow: 1px 1px 1px #000, 0 0 3px rgba(0, 0, 0, 0.8);
  }

  [data-window] [data-desktop-icon] > div:last-child {
    color: #000;
    text-shadow: none;
  }

  [data-desktop-icon][data-selected="true"] img {
    filter: brightness(0.75) sepia(1) hue-rotate(190deg) saturate(5);
  }

  [data-desktop-icon][data-selected="true"] > div:last-child,
  [data-window] [data-desktop-icon][data-selected="true"] > div:last-child {
    background: #00007b;
    color: #fff;
    text-shadow: none;
    outline: 1px dotted #ffff00;
  }

  /* Apply to specific elements that commonly have scrollbars */
  div, textarea, pre, code {
    ${scrollbarStyles}
  }
`;
